import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-486d84e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-login w-full h-screen" }
const _hoisted_2 = { class: "logo flex justify-center" }
const _hoisted_3 = { class: "flex justify-center" }
const _hoisted_4 = { class: "card flex items-center justify-center flex-col rounded overflow-hidden shadow-lg gap-4" }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "flex flex-col gap-2 items-center justify-between" }
const _hoisted_8 = { class: "title" }
const _hoisted_9 = { class: "invite-content text-center leading-7" }
const _hoisted_10 = {
  class: "text-bold underline decoration-2 decoration-primary",
  id: "nomeEmpresa"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-4 mb-2" }, " Verifiquei aqui e você ainda não possui uma conta no aplicativo, por favor cadastre-se para poder aceitar o convite da nossa empresa. ", -1))
const _hoisted_13 = { class: "register flex flex-col items-center" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "CRM-UF:", -1))
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "flex flex-col gap-2 items-center" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "Dr(a) acesse sua conta", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "subtitle" }, "Para visualizar o convite por favor acesse sua conta!", -1))
const _hoisted_19 = { class: "input w-80 mt-3" }
const _hoisted_20 = { class: "input w-80" }
const _hoisted_21 = { class: "recover-password" }
const _hoisted_22 = { class: "login m-3" }
const _hoisted_23 = { key: 2 }
const _hoisted_24 = {
  key: 0,
  class: "flex flex-col gap-2 items-center"
}
const _hoisted_25 = { class: "title" }
const _hoisted_26 = { class: "invite-content text-center leading-7" }
const _hoisted_27 = {
  class: "text-bold underline decoration-2 decoration-primary",
  id: "nomeEmpresa"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_29 = { class: "flex items-center" }
const _hoisted_30 = { class: "login m-3" }
const _hoisted_31 = { key: 1 }
const _hoisted_32 = {
  key: 0,
  class: "title"
}
const _hoisted_33 = {
  key: 1,
  class: "title"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "subtitle" }, "Clique para abrir o aplicativo!", -1))

import { ref, onBeforeMount, reactive } from 'vue'
import Logo from '@/components/designSystem/Logo/index.vue'
import { useRoute } from 'vue-router'
import InvalidTokenPage from './components/invalidTokenPage.vue'
import Network from '@/Network'
import { useToast } from 'vue-toastification'
import { schemaValidate } from '@/utils/yup'
import { capitalizeFullName } from '@/utils/string'
import { states, LoginSchema } from '@/modules/public/Signin/schemas'
import GenericInput from '@/components/designSystem/Inputs/GenericInput.vue'
import GhostButton from '@/components/designSystem/Buttons/GhostButton/index.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import PasswordInput from '@/components/designSystem/Inputs/PasswordInput.vue'
import ConfirmAlert from '@/components/designSystem/Alerts/ConfirmAlert.vue'
import AppStoreBadges from '@/components/designSystem/AppStoreBadges/index.vue'
import { EModals, useModalStore } from '@/pinia-store/useModalStore'
import DoctorSignupModal from '@/modules/public/ManageInviteDoctor/modals/doctor.signup.modal.vue'
import { VForm } from 'vuetify/lib/components/index.mjs'
import { useAuthStore } from '@/pinia-store/useAuthStore'
import { CompanyDoctorInviteStatusEnum } from '@/Network/Types/Requests/CompanyRequests'
import { useErrorToast } from '@/composables/useErrorToast'
import { getApiErrorStatus } from '@/utils/apiError'

const INVALID_INVITE_LINK_MESSAGE =
  'Este link de convite é inválido ou expirou. Peça um novo convite à empresa.'


export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const toast = useToast()
const { notifyError, notifyErrorMessage } = useErrorToast()
const modalStore = useModalStore()
const authStore = useAuthStore()

const token = ref('')
const invalidToken = ref(false)
const existUser = ref(false)
const companyName = ref('')
const androidUrl = ref('#')
const iosUrl = ref('#')
const companyDoctorInviteId = ref(0)
const isCompanyDoctorInviteAcceptSucces = ref(false)
const isCompanyDoctorInviteRefuseSucces = ref(false)
const doctorCrm = reactive({ name: '', number: '', uf: '' })
const isLoading = ref(false)
const isConfirmedCrm = ref(false)
const showDialogAccept = ref(false)
const showDialogRefuse = ref(false)

const route = useRoute()

const loginForm = reactive(states)
const elLoginForm = ref<typeof VForm | null>(null)

const isAuthenticated = () => {
  if (existUser.value) {
    const accessToken = localStorage.getItem('@ME:doctor_access_token')

    // Verifica se o token de acesso está presente e não está vazio
    return accessToken !== null && accessToken !== ''
  }
  return false
}

const rules = reactive({
  email: () => {
    return !loginForm.errors.email || loginForm.errors.email
  },
  password: () => {
    return !loginForm.errors.password || loginForm.errors.password
  }
})

const validate = async (field: string) => {
  await schemaValidate(field, loginForm, LoginSchema)
}

const openSignupModal = () => {
  modalStore.toggleModal(EModals.DOCTOR_SIGNUP)
}

const acceptInvite = () => {
  showDialogAccept.value = true
}

const refuseInvite = () => {
  showDialogRefuse.value = true
}

const onConfirmAccept = async () => {
  try {
    toast.info('Aceitando convite...')

    const storesUrls = await Network.doctor.sendResponseToCompanyDoctorInvite({
      companyDoctorInviteId: companyDoctorInviteId.value,
      accept: true
    })
    androidUrl.value = storesUrls.androidUrl
    iosUrl.value = storesUrls.iosUrl
    isCompanyDoctorInviteAcceptSucces.value = true
    toast.success('Convite aceito com sucesso!')
  } catch (e) {
    console.error(e)
    notifyError(
      e,
      'Não foi possível aceitar o convite. Tente novamente ou entre em contato conosco.'
    )
  } finally {
    showDialogAccept.value = false
  }
}

const onCancelAccept = () => {
  showDialogAccept.value = false
}

const onConfirmRefuse = async () => {
  try {
    toast.info('Recusando convite...')

    const storesUrls = await Network.doctor.sendResponseToCompanyDoctorInvite({
      companyDoctorInviteId: companyDoctorInviteId.value,
      accept: false
    })

    androidUrl.value = storesUrls.androidUrl
    iosUrl.value = storesUrls.iosUrl
    isCompanyDoctorInviteRefuseSucces.value = true
    toast.success('Convite recusado com sucesso!')
  } catch (e) {
    notifyError(
      e,
      'Não foi possível recusar o convite. Tente novamente ou entre em contato conosco.'
    )
    console.error(e)
  } finally {
    showDialogRefuse.value = false
  }
}

const onCancelRefuse = () => {
  showDialogRefuse.value = false
}

/**
 * 404 = link inexistente/inválido: o backend responde 'Token inválido!' (termo
 * técnico), então o texto exibido é o curado deste módulo. Demais falhas (rede,
 * 5xx) seguem o funil canônico.
 */
const notifyInviteLinkError = (error: unknown) => {
  if (getApiErrorStatus(error) === 404) {
    notifyErrorMessage(INVALID_INVITE_LINK_MESSAGE)
  } else {
    notifyError(error, INVALID_INVITE_LINK_MESSAGE)
  }
}

const getCompanyDoctorInviteData = async () => {
  try {
    isLoading.value = true
    if (!route.query['token']) {
      invalidToken.value = true
      return
    }
    token.value = String(route.query['token'])
    const { data: doctorCompanyInvite } = await Network.doctors.validateTokenCompanyDoctorInvite(
      btoa(token.value)
    )

    if (doctorCompanyInvite.company.name) {
      companyName.value = doctorCompanyInvite.company.name
    }

    if (doctorCompanyInvite.id) {
      companyDoctorInviteId.value = doctorCompanyInvite.id
    }

    if (doctorCompanyInvite.doctor.mainCrm) {
      doctorCrm.name = capitalizeFullName(doctorCompanyInvite.doctor.mainCrm.name)
      doctorCrm.number = doctorCompanyInvite.doctor.mainCrm.number
      doctorCrm.uf = doctorCompanyInvite.doctor.mainCrm.uf
    }

    if (doctorCompanyInvite.doctor.user) {
      existUser.value = true
    }

    if (doctorCompanyInvite.doctorStatus) {
      const status: CompanyDoctorInviteStatusEnum = doctorCompanyInvite.doctorStatus
      if (status === CompanyDoctorInviteStatusEnum.ACCEPTED) {
        isCompanyDoctorInviteAcceptSucces.value = true
      }
      if (status === CompanyDoctorInviteStatusEnum.DECLINED) {
        isCompanyDoctorInviteRefuseSucces.value = true
      }
    }
  } catch (e) {
    console.error(e)
    notifyInviteLinkError(e)
    token.value = ''
    invalidToken.value = true
  } finally {
    isLoading.value = false
  }
}

const onSuccessSubmitSignup = async () => {
  await getCompanyDoctorInviteData()
}

onBeforeMount(async () => {
  await getCompanyDoctorInviteData()
})

async function submitLogin() {
  // const isValidForm = await schemaValidateAllFields(loginForm, LoginSchema)
  try {
    isLoading.value = true
    await authStore.loginDoctor({
      email: loginForm.values.email || '',
      password: loginForm.values.password || ''
    })
  } catch {
    console.error('Erro ao realizar login')
  } finally {
    isLoading.value = false
    await getCompanyDoctorInviteData()
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Logo, {
        width: "160px",
        logo: "full"
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (invalidToken.value)
          ? (_openBlock(), _createBlock(InvalidTokenPage, { key: 0 }))
          : _createCommentVNode("", true),
        (isLoading.value)
          ? (_openBlock(), _createBlock(_component_v_progress_circular, {
              key: 1,
              indeterminate: "",
              size: 128,
              width: 7,
              color: "primary"
            }))
          : (!invalidToken.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (!existUser.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("h1", _hoisted_8, "Olá, " + _toDisplayString(doctorCrm.name) + "!", 1),
                        _createElementVNode("div", _hoisted_9, [
                          _createTextVNode(" Nós da "),
                          _createElementVNode("span", _hoisted_10, _toDisplayString(companyName.value), 1),
                          _createTextVNode(" convidamos você para se juntar ao aplicativo Minha Escala."),
                          _hoisted_11,
                          _hoisted_12
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                          _createVNode(OutlineButton, {
                            onClick: openSignupModal,
                            disabled: !isConfirmedCrm.value,
                            text: "Registar meu usuário"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Registar meu usuário ")
                            ]),
                            _: 1
                          }, 8, ["disabled"]),
                          _createVNode(_component_v_checkbox, {
                            class: "confirm-checkbox",
                            density: "compact",
                            color: "primary",
                            modelValue: isConfirmedCrm.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isConfirmedCrm).value = $event))
                          }, {
                            label: _withCtx(() => [
                              _createTextVNode(" Confirmo, que sou portador do "),
                              _hoisted_14,
                              _createTextVNode("  "),
                              _createElementVNode("strong", null, _toDisplayString(`${doctorCrm.number}-${doctorCrm.uf}`), 1),
                              (!isConfirmedCrm.value)
                                ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                    key: 0,
                                    activator: "parent",
                                    location: "top"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Por favor confirme que é o portador do CRM")
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (existUser.value && !isAuthenticated())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _hoisted_17,
                        _hoisted_18,
                        _createVNode(_unref(VForm), {
                          "fast-fail": false,
                          class: "flex pt-4 items-center flex-col rounded overflow-hidden",
                          ref_key: "elLoginForm",
                          ref: elLoginForm
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_19, [
                              _createVNode(GenericInput, {
                                type: "email",
                                label: "Email",
                                modelValue: loginForm.values.email,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((loginForm.values.email) = $event)),
                                onValidate: _cache[2] || (_cache[2] = ($event: any) => (validate('email'))),
                                rules: [rules.email]
                              }, null, 8, ["modelValue", "rules"])
                            ]),
                            _createElementVNode("div", _hoisted_20, [
                              _createVNode(PasswordInput, {
                                modelValue: loginForm.values.password,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((loginForm.values.password) = $event)),
                                onValidate: _cache[4] || (_cache[4] = ($event: any) => (validate('password'))),
                                rules: [rules.password]
                              }, null, 8, ["modelValue", "rules"])
                            ]),
                            _createElementVNode("div", _hoisted_21, [
                              _createVNode(_component_router_link, { to: "/forgot-password" }, {
                                default: _withCtx(() => [
                                  _createVNode(GhostButton, { text: "Esqueci minha senha" })
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_22, [
                              _createVNode(FilledButton, {
                                onClick: submitLogin,
                                text: "Entrar"
                              })
                            ])
                          ]),
                          _: 1
                        }, 512)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (existUser.value && isAuthenticated())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      (!isCompanyDoctorInviteAcceptSucces.value && !isCompanyDoctorInviteRefuseSucces.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                            _createElementVNode("h1", _hoisted_25, "Olá, " + _toDisplayString(doctorCrm.name) + "!", 1),
                            _createElementVNode("div", _hoisted_26, [
                              _createTextVNode(" Nós da "),
                              _createElementVNode("span", _hoisted_27, _toDisplayString(companyName.value), 1),
                              _createTextVNode(" convidamos você para se juntar ao nosso time no aplicativo Minha Escala."),
                              _hoisted_28
                            ]),
                            _createElementVNode("div", _hoisted_29, [
                              _createElementVNode("div", null, [
                                _createVNode(FilledButton, {
                                  onClick: refuseInvite,
                                  color: "error",
                                  width: "200px",
                                  text: "Recusar Convite"
                                })
                              ]),
                              _createElementVNode("div", _hoisted_30, [
                                _createVNode(FilledButton, {
                                  onClick: acceptInvite,
                                  width: "200px",
                                  text: "Aceitar convite"
                                })
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (isCompanyDoctorInviteAcceptSucces.value || isCompanyDoctorInviteRefuseSucces.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                            (isCompanyDoctorInviteAcceptSucces.value)
                              ? (_openBlock(), _createElementBlock("h1", _hoisted_32, " Convite foi aceito com sucesso! "))
                              : (isCompanyDoctorInviteRefuseSucces.value)
                                ? (_openBlock(), _createElementBlock("h1", _hoisted_33, " Convite foi recusado com sucesso! "))
                                : _createCommentVNode("", true),
                            _hoisted_34,
                            _createVNode(AppStoreBadges, {
                              class: "mt-5",
                              "android-url": androidUrl.value,
                              "ios-url": iosUrl.value
                            }, null, 8, ["android-url", "ios-url"])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(DoctorSignupModal, { onOnSuccessSubmit: onSuccessSubmitSignup }),
    (showDialogAccept.value)
      ? (_openBlock(), _createBlock(ConfirmAlert, {
          key: 0,
          "show-alert": showDialogAccept.value,
          onOnConfirm: onConfirmAccept,
          onOnCancel: onCancelAccept
        }, null, 8, ["show-alert"]))
      : _createCommentVNode("", true),
    (showDialogRefuse.value)
      ? (_openBlock(), _createBlock(ConfirmAlert, {
          key: 1,
          "show-alert": showDialogRefuse.value,
          onOnConfirm: onConfirmRefuse,
          onOnCancel: onCancelRefuse
        }, null, 8, ["show-alert"]))
      : _createCommentVNode("", true)
  ]))
}
}

})